<template>
    <div class="form-info">
        <div class="form-row">
            <div class="form-label">
                <label>流程名称</label>
            </div>
            <div class="form-value">
                <span>{{devcInspectFlowInfo.name}}</span>
            </div>
        </div>
        <div class="form-row">
            <div class="form-label">
                <label>流程特点</label>
            </div>
            <div class="form-value" style="width: calc(100% - 146px);width: -webkit-calc(100% - 146px);">
                <span>{{devcInspectFlowInfo.feature}}</span>
            </div>
        </div>
        <div class="form-row">
            <div class="form-label">
                <label>是否禁用</label>
            </div>
            <div class="form-value">
                <span>{{devcInspectFlowInfo.disabled ? "是" : "否"}}</span>
            </div>
        </div>
        <div class="form-row" v-if="devcInspectFlowInfo.disabled">
            <div class="form-label">
                <label>禁用原因</label>
            </div>
            <div class="form-value" style="width: calc(100% - 146px);width: -webkit-calc(100% - 146px);">
                <span>{{devcInspectFlowInfo.disableCause}}</span>
            </div>
        </div>
        <div class="form-row">
            <div class="form-label">
                <label>创建人</label>
            </div>
            <div class="form-value">
                <span>{{devcInspectFlowInfo.creatorName}}</span>
            </div>
        </div>
        <div class="form-row">
            <div class="form-label">
                <label>创建时间</label>
            </div>
            <div class="form-value">
                <span>{{devcInspectFlowInfo.createTime}}</span>
            </div>
        </div>

        <div class="form-row" style="height: auto;overflow: hidden">
            <div class="form-label">
                <label>备注</label>
            </div>
            <div class="form-value" style="width: calc(100% - 146px);width: -webkit-calc(100% - 146px);">
                <span>{{devcInspectFlowInfo.desc || '无'}}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    import rentServcApi from '../../api/rentServc';

    export default {
        name: 'swb-devc-inspect-flow-info',
        path: '/devc/inspect/flow/info',
        props: ['id'],
        desc: '设备检验流程-详情',
        data: function () {
            return {
                devcInspectFlowInfo: {},
            }
        },
        created: function () {
            //
            this.getDevcInspectFlowInfo();
        },
        methods: {
            getDevcInspectFlowInfo: function () {
                let self = this;
                let postData = {
                    id: self.id,
                };
                let theLoading = MsgBox.loading();
                rentServcApi.getDevcInspectFlowInfo(postData, function (result) {
                    theLoading.close();
                    if(result.type === "info") {
                        //
                        self.devcInspectFlowInfo = result.data || {};
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/rentServc/DevcInspectFlowInfo.vue